<script>
export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("mouseup", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("mouseup", el.clickOutsideEvent);
  },
};
</script>